import React from 'react';
import PropTypes from 'prop-types';

export const SelectContainer = ({children, elementClass}) => {
    return (
        <div className={`select-container ${elementClass}`}>
            {children}
        </div>
    )
};

SelectContainer.propTypes = () => ({
    children: PropTypes.string,
    elementClass: PropTypes.string,
});
